import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { BackendStatusService } from './backend-status.service';
import { Icon } from '../../shared/icon/icon';

/**
 * Barra global de "backend caído". Vive en el template raíz (app.html), fuera del Shell,
 * para cubrir también al login. Persistente mientras dure la caída: el estado lo maneja
 * BackendStatusService (reintento automático cada 15s + "Probar ahora" manual).
 */
@Component({
  selector: 'app-backend-down-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Icon],
  templateUrl: './backend-down-banner.html',
  styleUrl: './backend-down-banner.scss',
})
export class BackendDownBanner {
  protected readonly status = inject(BackendStatusService);
}
